import { c as _c } from "react/compiler-runtime";
import { LoaderIcon } from "lucide-react";
export const PreviewAttachment = t0 => {
  const $ = _c(14);
  const {
    attachment,
    isUploading: t1
  } = t0;
  const isUploading = t1 === undefined ? false : t1;
  const {
    name,
    url,
    contentType
  } = attachment;
  let t2;
  if ($[0] !== contentType || $[1] !== name || $[2] !== url) {
    t2 = contentType ? contentType.startsWith("image") ? <img key={url} src={url} alt={name ?? "An image attachment"} className="rounded-md size-full object-cover" /> : <div className="" /> : <div className="" />;
    $[0] = contentType;
    $[1] = name;
    $[2] = url;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isUploading) {
    t3 = isUploading && <div data-testid="input-attachment-loader" className="animate-spin absolute text-zinc-500"><LoaderIcon /></div>;
    $[4] = isUploading;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="w-20 h-16 aspect-video bg-muted rounded-md relative flex flex-col items-center justify-center">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== name) {
    t5 = <div className="text-xs text-zinc-500 max-w-16 truncate">{name}</div>;
    $[9] = name;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div data-testid="input-attachment-preview" className="flex flex-col gap-2">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};